var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { ApplicationContext } from '../../../../ApplicationContext';
import GetOrganisationAssetsCommand from '../../../../commands/assets/GetOrganisationAssetsCommand';
import AssetsMap from '../../../pages/Assets/AssetsMap';
import Signals from '../../../../signals/Signals';
/**
 *
 */
var MapWidget = /** @class */ (function (_super) {
    __extends(MapWidget, _super);
    /**
     *
     */
    function MapWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            initialized: false,
            errors: []
        };
        _this.onAssetDataUpdated = _this.onAssetDataUpdated.bind(_this);
        _this.onAssetDataError = _this.onAssetDataError.bind(_this);
        _this.updateAssets = _this.updateAssets.bind(_this);
        return _this;
    }
    /**
     *
     */
    MapWidget.prototype.componentDidMount = function () {
        this.updateAssets();
        // Setting an interval for refreshing asset data
        Signals.RefreshAssets.add(this.updateAssets);
    };
    MapWidget.prototype.componentWillUnmount = function () {
        Signals.RefreshAssets.removeAll();
    };
    /**
     *
     * @returns {*}
     */
    MapWidget.prototype.render = function () {
        var _a = this.context, session = _a.session, assetCollection = _a.assetCollection;
        var initialized = this.state.initialized;
        if (!session.isLoggedIn) {
            return null;
        }
        return (React.createElement("div", { className: "map-widget w-100 ".concat(this.props.className ? this.props.className : "") }, initialized ?
            React.createElement(AssetsMap, { assetCollection: assetCollection })
            :
                React.createElement("div", { className: "col-12 d-flex h-100 justify-content-center align-items-center" },
                    React.createElement("div", { className: "spinner-border text-primary", role: "status" },
                        React.createElement("span", { className: "sr-only" }, "Loading...")))));
    };
    /**
     *
     * @param response
     */
    MapWidget.prototype.onAssetDataUpdated = function (response) {
        this.setState({ initialized: true });
    };
    /**
     *
     * @param error
     */
    MapWidget.prototype.onAssetDataError = function (error) {
        this.setState({ initialized: true });
    };
    /**
     *
     */
    MapWidget.prototype.updateAssets = function () {
        var _a = this.context, session = _a.session, assetCollection = _a.assetCollection;
        var user = session.user;
        // Already initialized
        if (assetCollection.firstFetchComplete) {
            this.setState({ initialized: true });
        }
        var command = new GetOrganisationAssetsCommand();
        command.execute(user.organisation, assetCollection).then(this.onAssetDataUpdated).catch(this.onAssetDataError);
    };
    MapWidget = __decorate([
        observer
    ], MapWidget);
    return MapWidget;
}(React.Component));
MapWidget.contextType = ApplicationContext;
export default injectIntl(MapWidget);
